import * as go from 'gojs/release/go-module';

import { Layer } from 'src/containers/ProjectDiagram/constants/layers';
import {
  DRAFT_OUTLINE_COLOR,
  LINK_ARROW_SCALE,
  LINK_COLOR,
  LINK_SELECTED_WIDTH,
  LINK_WIDTH,
} from 'src/containers/ProjectDiagram/constants/styles';
import {
  graphObjectMouseEnter,
  graphObjectMouseLeave,
} from 'src/containers/ProjectDiagram/handlers/graphObject';
import { ExtendedLink } from 'src/containers/ProjectDiagram/templates/extensions/link';
import {
  modelBinding,
  objectBinding,
} from 'src/containers/ProjectDiagram/templates/helpers/binding';
import { isHierarchyModified } from 'src/containers/ProjectDiagram/templates/helpers/draft';
import { determineColorFromSelection } from 'src/containers/ProjectDiagram/templates/helpers/styles';
import { ModelConceptHierarchyLink } from 'src/containers/ProjectDiagram/types/diagram';
import { ModelData } from 'src/containers/ProjectDiagram/types/model';

const determineHierarchyColor = determineColorFromSelection(
  isHierarchyModified,
  LINK_COLOR,
  DRAFT_OUTLINE_COLOR
);

const $ = go.GraphObject.make;

export const createModelConceptHierarchyTemplate = ({
  contextMenu,
  handleClick,
  handleDoubleClick,
}: {
  contextMenu: go.HTMLInfo;
  handleClick: NonNullable<ModelConceptHierarchyLink['click']>;
  handleDoubleClick: NonNullable<ModelConceptHierarchyLink['doubleClick']>;
}) =>
  $(
    ExtendedLink,
    {
      click: handleClick,
      contextMenu,
      cursor: 'pointer',
      curve: go.Link.Bezier,
      doubleClick: handleDoubleClick,
      layerName: Layer.MODEL_CONCEPT_HIERARCHY_BACKGROUND_LAYER,
      mouseEnter: graphObjectMouseEnter,
      mouseLeave: graphObjectMouseLeave,
      movable: false,
      selectionAdorned: false,
      toShortLength: LINK_ARROW_SCALE * LINK_WIDTH,
    },

    objectBinding<go.Link, go.Link>()('layerName', 'isSelected', (isSelected) =>
      isSelected
        ? Layer.MODEL_CONCEPT_HIERARCHY_FOREGROUND_LAYER
        : Layer.MODEL_CONCEPT_HIERARCHY_BACKGROUND_LAYER
    ),

    $(
      go.Shape, // the line
      {
        name: 'MAIN',
        isPanelMain: true,
        stroke: LINK_COLOR,
        strokeWidth: LINK_WIDTH,
      },
      modelBinding<go.Shape, ModelData>()(
        'stroke',
        '',
        determineHierarchyColor
      ),
      objectBinding<go.Shape, go.Link>()('strokeWidth', '', (link) =>
        link.isHighlighted || link.isSelected ? LINK_SELECTED_WIDTH : LINK_WIDTH
      )
    ),

    $(
      go.Shape, // the arrow head
      {
        name: 'ARROW',
        toArrow: 'Triangle',
        fill: LINK_COLOR,
        stroke: LINK_COLOR,
        scale: LINK_ARROW_SCALE,
      },
      modelBinding<go.Shape, ModelData>()(
        'stroke',
        '',
        determineHierarchyColor
      ),
      modelBinding<go.Shape, ModelData>()('fill', '', determineHierarchyColor),
      objectBinding<go.Shape, go.Link>()('scale', '', (link) =>
        link.isHighlighted || link.isSelected
          ? LINK_ARROW_SCALE * 1.5
          : LINK_ARROW_SCALE
      )
    )
  );
